const AttributesListsAdd = () =>
  import("@/pages/lab/attributeslists/AttributesListsAdd");
const AttributesListsEdit = () =>
  import("@/pages/lab/attributeslists/AttributesListsEdit");
const AttributesListsDetail = () =>
  import("@/pages/lab/attributeslists/AttributesListsDetail.vue");

export class AttributesListsRoutes {
  constructor() {
    this.route_root = "attributes-lists";
    this.type_single = "Attributes List";
    this.type_plural = "Attributes Lists";

    /**
     * Define routes array
     * @type {*[]}
     */

    this.routes = [
      {
        path: this.route_root + "/add",
        name: "Add " + this.type_single,
        component: AttributesListsAdd,
        meta: { requiresAuth: true }
      },
      {
        path: `${this.route_root}/:id`,
        name: `${this.type_single} Detail`,
        component: AttributesListsDetail,
        meta: { requiresAuth: true }
      },
      {
        path: this.route_root + "/:id/edit",
        name: "Update " + this.type_single,
        component: AttributesListsEdit,
        meta: { requiresAuth: true }
      }
    ];

    /**
     * Define public routes array
     * @type {Array}
     */
    this.public_routes = [];
  }

  /**
   * Fetch rout definitions statically
   * @returns {*[]|*}
   */
  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  /**
   * Fetch public routes array
   * @returns {Array}
   */
  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
